<template>
  <v-col class="feedback-content">
    <v-row class="mb-4">
      <v-col>
        <h1 class="headline font-weight-bold mb-2">
          Feedback
        </h1>
        <p class="body-1 coolgray--text mb-0">
          Learn how in-app feedback works, what happens after you submit,
          and how to validate the workflow in QA.
        </p>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'message']"
              class="primary--text mr-2"
            />
            How to Submit Feedback
          </h2>

          <ol class="body-2 mb-0">
            <li class="mb-2">
              Open the <strong>Help</strong> menu in the header.
            </li>
            <li class="mb-2">
              Select <strong>Give Feedback</strong>.
            </li>
            <li class="mb-2">
              Choose a category and enter:
              <ul class="mt-1 mb-0">
                <li><strong>Summary</strong> (3-140 characters)</li>
                <li><strong>Details</strong> (10-5000 characters)</li>
              </ul>
            </li>
            <li>
              Submit the form. You will see a success or error message in the app.
            </li>
          </ol>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'diagram-project']"
              class="success--text mr-2"
            />
            What the Server Does
          </h2>

          <p class="body-2 mb-3">
            After submission, the backend processes feedback in a secure flow.
          </p>

          <ul class="body-2 mb-0">
            <li class="mb-2">
              Authenticates the request and rejects unauthorized submissions
              with <strong>403 Unauthorized</strong>.
            </li>
            <li class="mb-2">
              Sanitizes and validates category, summary, and details.
            </li>
            <li class="mb-2">
              Accepts only valid categories:
              <strong>general, bug, feature, question, other</strong>.
            </li>
            <li class="mb-2">
              Creates a feedback record with request metadata and
              context (route path, report key, route name).
            </li>
            <li class="mb-2">
              Stores the record in Firestore collection <strong>feedback</strong>
              with status <strong>new</strong>.
            </li>
            <li>
              Returns <strong>200</strong> on success, or <strong>400/500</strong>
              with an actionable message when validation or storage fails.
            </li>
          </ul>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mb-6">
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'flask']"
              class="warning--text mr-2"
            />
            QA Validation Checklist
          </h2>

          <p class="body-2 mb-3">
            For test execution details, use the dedicated QA checklist entry.
          </p>

          <v-btn
            outlined
            class="text-none"
            to="/docs/test/feedback"
          >
            <font-awesome-icon
              :icon="['fas', 'list-check']"
              class="mr-2"
              size="sm"
            />
            Open Feedback QA Checklist
          </v-btn>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card
          outlined
          class="pa-4"
        >
          <h2 class="subtitle-1 font-weight-bold mb-3 d-flex align-center">
            <font-awesome-icon
              :icon="['fas', 'circle-info']"
              class="info--text mr-2"
            />
            Notes for Users
          </h2>

          <ul class="body-2 mb-0">
            <li class="mb-2">
              Feedback is tied to your authenticated account.
            </li>
            <li class="mb-2">
              Include steps to reproduce and expected behavior for faster triage.
            </li>
            <li>
              Submissions from the production site and remote preview channels are
              sent to the cloud backend.
            </li>
          </ul>
        </v-card>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: 'FeedbackContent',
}
</script>

<style lang="scss" scoped>
.feedback-content {
  max-width: 900px;
}

ul, ol {
  padding-left: 20px;
}

ul ul {
  margin-top: 4px;
  padding-left: 16px;
}
</style>
